<template>
<div class="section section-2 py-md-5">
  <div class="container">
    <h2 class="text-center section__title-principal mb-3">Estadísticas por región</h2>
    <div class="row">
      <div class="col-12 col-md-6">
          <div class="section__title">
            <h2>CORONAVIRUS <span>en {{ getZonaById(datos[0].id) }}</span></h2>
          </div>
          <div class="section__box-select">
            <multiselect
              v-model="selectedRegion"
              track-by="value"
              label="text"
              placeholder="Seleccione una región"
              :options="regiones"
              @input="changeRegion"
              selectLabel="Presione enter para seleccionar"
              deselectLabel="Presiones enter para remover"
              selectedLabel="Seleccionado"
              >
              <template slot="noResult">Sin resultados</template>
              <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.text }}</strong></template>
            </multiselect>
          </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="section__title pt-3 pt-md-0">
          <h2>CORONAVIRUS <span>en {{ getZonaById(datos[1].id) || `comunas de ${getZonaById(datos[0].id)}` }}</span></h2>
        </div>
        <div class="section__box-select">
        <multiselect
          v-model="selectedComuna"
          track-by="value"
          label="text"
          placeholder="Seleccione una comuna"
          :options="comunas"
          @input="changeComunas"
          selectLabel="Presione enter para seleccionar"
          deselectLabel="Presiones enter para remover"
          selectedLabel="Seleccionado"
          >
          <template slot="noResult">Sin resultados</template>
          <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.text }}</strong></template>
        </multiselect>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="chart-selection">
        <div class="row">
          <div class="col-12 col-md-6 d-flex align-items-center">
          <div v-for="radioButton in radioButtons" :key="radioButton.value" class="custom-control custom-radio custom-control-inline">
            <input type="radio" class="custom-control-input" :id="radioButton.id" name="regiones" @change="updateChart" v-model="selectedTipo" :value="radioButton.value" :checked="radioButton.checked">
            <label class="custom-control-label" :for="radioButton.id">{{radioButton.name}}</label>
          </div>
          </div>
          <div class="col-12 col-md-6">
            <date-picker v-model="range" @change="changeRange" valueType="format" range :disabledDate="disableDates" :clearable="false"/>
          </div>
        </div>
      </div>
      <div class="chart-line">
        <canvas ref="chart"></canvas>
      </div>
      <div class="chart-legend">
        <ul class="legend">
          <li><b>{{ getZonaById(datos[0].id) }}:</b></li>
          <li class="legend__item legend__item--solid">Contagios</li>
          <li class="legend__item legend__item--dashed">Fallecidos</li>
        </ul>
        <ul class="legend">
          <li><b>{{ getZonaById(datos[1].id) || `Comunas de ${getZonaById(datos[0].id)}` }}:</b></li>
          <li class="legend__item legend__item--solid">Contagios</li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <grm-tasa label="Tasas regiones" :datos="this.datos[0]"/>
      </div>
      <div class="col-12 col-md-6">
        <grm-tasa label="Tasas comunas" :datos="this.datos[1]"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';
import { chartDefaults, processData, disableDates } from '../../charts'
import { getRegiones, getRegionesData, getComunas, getComunasData } from '../../api'
import { getRegionByDiario } from '../../api/regionbydiario'
import GrmTasa from '../commons/GrmTasa'
export default {
  data() {
    return {
      chart: null,
      regiones: [],
      comunas: [],
      range: [],
      selectedRegion: null,
      selectedComuna: null,
      selectedTipo: 'contagios',
      datos: [
        { id: null, data: [] }, // Región
        { id: null, data: [] } // Otras comunas
      ],
      radioButtons:[
        { id:'contagiosButtonRegion',  value:'contagios', name:'Contagios', checked: true },
        { id:'fallecidosButtonRegion', value:'fallecidos', name:'Fallecidos' }
      ]
    }
  },

  methods: {
    async updateChart() {
      // ¿no hay grafico? no hacemos nada
      if (!this.chart) return false

      this.chart.data.datasets = []
      this.datos.forEach((dato, index) => {
        let datos = processData(this.selectedTipo, dato.data, index)
        this.chart.data.datasets.push({
          label: `${this.getZonaById(this.datos[index].id)} - ${this.selectedTipo}`,
          data: datos.data,
          borderDash: datos.borderDash,
          borderColor: datos.borderColor(),
          pointBorderColor: datos.borderColor(),
          pointStyle: datos.pointStyle,
          pointHoverBorderColor: datos.borderColor(),
          pointBackgroundColor: datos.borderColor(),
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderWidth: 4,
          pointHoverRadius: 6,
          pointHitRadius: 10,
          spanGaps: true
        })

        if (index === 0) {
          this.chart.data.labels = datos.labels
        }
      })

      this.chart.update()
    },

    async createChart() {
      const datos = processData('contagios', this.datos[0].data)

      this.chart = new this.$chart(this.$refs.chart, {
        type: 'line',
        data: {
          labels: datos.labels,
          datasets:[{
            label: `${this.getZonaById(this.datos[0].id)} - contagios`,
            data: datos.data,
            borderColor: datos.borderColor,
            pointBorderColor: datos.borderColor,
            pointHoverBorderColor: datos.borderColor,
            pointBackgroundColor: datos.borderColor,
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderWidth: 4,
            pointHoverRadius: 6,
            pointHitRadius: 10,
            labelColors: '#000'
          }],
        },
        options: chartDefaults.lineChart
      })
    },

    async changeRegion() {
       if (!this.selectedRegion) return false

      const datos = await getRegionesData(this.selectedRegion.value, this.range)

      // Seteamos los datos de la región solicitada
      this.$set(this.datos[0], 'id', this.selectedRegion.value)
      this.$set(this.datos[0], 'data', datos.data)
      this.$set(this.datos[0], 'habitantes', datos.habitantes)
      this.$set(this.datos[0], 'ultimaActualizacion', datos.ultimaActualizacion)

      // Borramos los datos de la comuna por si había una seleccionada
      // esto es para que no queden datos de la región anterior
      this.datos[1].id = null
      this.datos[1].data = []

      // Obtenemos las comunas de la nueva región seleccionada.
      this.comunas = await getComunas(this.selectedRegion.value)

      // actualizamos el gráfico
      this.updateChart()
    },

    async changeComunas() {
       if (!this.selectedComuna) return false

      const datos = await getComunasData(this.selectedComuna.value, this.range)

      // Seteamos los datos de la comuna solicitada
      this.$set(this.datos[1], 'id', this.selectedComuna.value)
      this.$set(this.datos[1], 'data', datos.data)
      this.$set(this.datos[1], 'habitantes', datos.habitantes)
      this.$set(this.datos[1], 'ultimaActualizacion', datos.ultimaActualizacion)

      this.updateChart()
    },

    async changeRange() {
      let datos = await getRegionesData(this.datos[0].id, this.range)

      // Este es el dato de la izquierda, las regiones
      this.$set(this.datos[0], 'data', datos.data)
      this.$set(this.datos[0], 'habitantes', datos.habitantes)
      this.$set(this.datos[0], 'ultimaActualizacion', datos.ultimaActualizacion)

      // Solo si tenemos datos para la comuna (derecha) hacemos la llamada a la api
      if (this.datos[1].id) {
        let datosDer = await getComunasData(this.datos[1].id, this.range)
        this.$set(this.datos[1], 'data', datosDer.data)
        this.$set(this.datos[1], 'habitantes', datosDer.habitantes)
        this.$set(this.datos[1], 'ultimaActualizacion', datosDer.ultimaActualizacion)
      }

      this.updateChart()
    },

    getZonaById(id) {
      let zona
      if (!id) return false

      for (let i = 0; i < this.regiones.length; i++) {
        if (this.regiones[i].value === id) {
          zona = this.regiones[i].text
        }
      }

      if (!zona) {
        for (let i = 0; i < this.comunas.length; i++) {
          if (this.comunas[i].value === id) {
            zona = this.comunas[i].text
          }
        }
      }

      return zona
    },

    disableDates: disableDates
  },

  components: { DatePicker, GrmTasa },

  async mounted() {
    let id = window.app.idDiario
    this.datos[0].id = getRegionByDiario(id)
    const datos = await getRegionesData(this.datos[0].id, this.range)

    // Seteamos los datos de la comuna solicitada
    this.$set(this.datos[0], 'data', datos.data)
    this.$set(this.datos[0], 'habitantes', datos.habitantes)
    this.$set(this.datos[0], 'ultimaActualizacion', datos.ultimaActualizacion)

    this.regiones = await getRegiones()

    this.comunas = await getComunas(this.datos[0].id)

    this.selectedRegion = this.regiones.find(region => region.value === this.datos[0].id)

    this.createChart()
  },

  created() {
    let date = new Date();
    date.setDate(date.getDate() - 30);
    this.range = [date.toISOString().slice(0,10), new Date().toISOString().slice(0,10)]
  }
}
</script>
